var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-reset_name_form" },
    [
      _c("CustomForm", {
        ref: "resetNameForm",
        staticClass: "form",
        attrs: {
          "form-data": _vm.ruleFormData,
          model: _vm.formModelData,
          "label-width": `0`,
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("CustomInput", {
                  attrs: {
                    value: _vm.formModelData.content,
                    placeholder: "请输入名称",
                    maxlength: _vm.maxlength,
                    showWordLimit: true,
                  },
                  on: {
                    "update:value": function ($event) {
                      return _vm.$set(_vm.formModelData, "content", $event)
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }